import { render, staticRenderFns } from "./FormDetailConsult.vue?vue&type=template&id=c8304bfa&scoped=true&"
import script from "./FormDetailConsult.vue?vue&type=script&lang=js&"
export * from "./FormDetailConsult.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailConsult.vue?vue&type=style&index=0&id=c8304bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8304bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8304bfa')) {
      api.createRecord('c8304bfa', component.options)
    } else {
      api.reload('c8304bfa', component.options)
    }
    module.hot.accept("./FormDetailConsult.vue?vue&type=template&id=c8304bfa&scoped=true&", function () {
      api.rerender('c8304bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/knowledge/FormDetailConsult.vue"
export default component.exports